import React from "react";

function PortfolioIcon({
  className,
  style,
}: {
  className?: string;
  style?: object;
}) {
  return (
    <svg className={className} style={style} viewBox="0 0 22.447 20.721">
      <g transform="translate(-3.375 -4.499)">
        <path
          d="M22.585,11.25H6.613a3.24,3.24,0,0,0-3.238,3.238v9.065A3.24,3.24,0,0,0,6.613,26.79H22.585a3.24,3.24,0,0,0,3.238-3.238V14.488A3.24,3.24,0,0,0,22.585,11.25Z"
          transform="translate(0 -1.57)"
        />
        <path
          d="M19.549,4.554,6.874,7.031C5.9,7.246,4.5,8.223,4.5,9.41A3.4,3.4,0,0,1,7.144,8.385H22.63V7.279a3.1,3.1,0,0,0-.75-2.029h0A2.552,2.552,0,0,0,19.549,4.554Z"
          transform="translate(-0.262)"
        />
      </g>
    </svg>
  );
}

export { PortfolioIcon };
